import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Button, Heading2, Text } from '@blueprint/ui';

export const Image = styled.img(
    ({ theme: { mq, spacing } }) =>
        css`
            display: flex;
            max-width: 100%;
            width: 90%;
            height: auto;
            margin: ${spacing['24px']} ${spacing['16px']};

            ${mq.medium} {
                width: 94%;
                max-width: 341px;
                height: auto;
            }

            ${mq.large} {
                max-width: 552px;
                height: auto;
                margin: 53px ${spacing['32px']};
            }
        `
);

export const Wrapper = styled.div(
    ({ theme: { mq, colors, borderRadius, spacing } }) =>
        css`
            display: flex;
            flex-direction: column;
            background-color: ${colors['tone-maroon-t4']};
            margin: ${spacing['32px']} ${spacing['16px']} 0 ${spacing['16px']};
            border-radius: ${borderRadius['8px']};
            cursor: pointer;

            ${mq.medium} {
                flex-direction: row;
                max-width: 100%;
                align-items: flex-start;
                margin: ${spacing['32px']} 0 0 0;
            }

            ${mq.large} {
                margin-top: 96px;
            }
        `
);

export const MainContent = styled.div(
    ({ theme: { spacing, mq } }) =>
        css`
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: ${spacing['16px']} 0 ${spacing['24px']} ${spacing['16px']};

            ${mq.medium} {
                margin-right: ${spacing['24px']};
                padding-top: 0;
                padding-left: 0;
            }

            ${mq.large} {
                padding: ${spacing['24px']} 0;
                width: 50%;
            }
        `
);

export const Heading = styled(Heading2)(
    ({ theme: { spacing, mq } }) =>
        css`
            margin: 0 ${spacing['16px']} ${spacing['8px']} 0;

            ${mq.medium} {
                margin-top: ${spacing['32px']};
            }

            ${mq.large} {
                font-size: ${spacing['32px']};
            }
        `
);

export const Description = styled(Text)(
    ({ theme: { spacing, mq } }) =>
        css`
            margin: 0 ${spacing['16px']} ${spacing['24px']} 0;

            ${mq.medium} {
                margin-bottom: ${spacing['16px']};
            }

            ${mq.large} {
                margin-bottom: ${spacing['24px']};
                max-width: 500px;
                font-size: 1.125rem;
            }
        `
);

export const AgentValuationButton = styled(Button)(
    ({ theme: { spacing, mq } }) =>
        css`
            margin: 0 ${spacing['16px']} 0 0;

            ${mq.medium} {
                max-width: 250px;
            }
        `
);
